import type { RouteRecordRaw } from 'vue-router'
import AuthRoutes from './auth'
import AppRoutes from './app'
import PartnerRoutes from './partner'
import OrganizationRoutes from './organization'
import External from './external'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: () => ({ name: 'Login' }),
  },
  ...AuthRoutes,
  ...AppRoutes,
  ...OrganizationRoutes,
  ...PartnerRoutes,
  ...External,
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: (): Promise<unknown> => import('@base/BaseNotFound.vue'),
  },
]

export default routes
